import {
  SEARCH_FILTER_COOKINGTIME,
  SEARCH_FILTER_COOKINGTIME_SPEEDY,
  SEARCH_FILTER_RATING,
  SEARCH_FILTER_RATING_POPULAR,
  SEARCH_FILTER_SEASON,
  SEARCH_FILTER_SEASON_WINTER,
} from '@mindfulchefuk/constants'

export default [
  {
    title: 'Most popular recipes',
    image: 'recipes/quick-search-categories/popular-recipes.jpg',
    filterType: `multiRange[${SEARCH_FILTER_RATING}]`,
    filterValue: SEARCH_FILTER_RATING_POPULAR,
  },
  {
    title: 'Winter recipes',
    image: 'recipes/quick-search-categories/winter-recipes.jpg',
    filterType: `menu[${SEARCH_FILTER_SEASON}]`,
    filterValue: SEARCH_FILTER_SEASON_WINTER,
  },
  {
    title: 'Quick recipes',
    image: 'recipes/quick-search-categories/speedy-recipes.jpg',
    filterType: `multiRange[${SEARCH_FILTER_COOKINGTIME}]`,
    filterValue: SEARCH_FILTER_COOKINGTIME_SPEEDY,
  },
]
